import { ICONS_MAP } from './icons';
import { LOGOS_MAP } from './logos';

export const ASSETS_MAP = {
    icons: ICONS_MAP,
    logos: LOGOS_MAP,
};
